import * as Yup from 'yup';

const stringValidation = ({
  min = 0,
  max = 255,
  pattern = '',
  patternMsg = 'Is not in correct format',
} = {}) =>
  Yup.string()
    .trim()
    .min(min, `Minimum of ${min} characters`)
    .matches(new RegExp(`${pattern}`), patternMsg)
    .max(max, `${max} character maximum`)
    .required('Required')
    .nullable();

const companyNameValidation = ({ min = 4 } = {}) =>
  stringValidation({
    min,
  });

const usernameValidation = ({
  min = 4,
  pattern = '^(?=.*[A-Za-z])[A-Za-z0-9]*$',
  patternMsg = 'Special characters not allowed. Valid characters are A-Z a-z 0-9',
} = {}) =>
  stringValidation({
    min,
    pattern,
    patternMsg,
  });

const emailValidation = ({ max = 50 } = {}) =>
  Yup.string().email('Must be a valid email').max(max).required('Required');

const phoneValidation = ({
  pattern = '^[0-9]{3}-[0-9]{3}-[0-9]{4}$',
  patternMsg = '10 numbers, ex. "888-432-5555"',
} = {}) =>
  stringValidation({
    pattern,
    patternMsg,
  });

const cityValidation = ({ pattern = '^[a-zA-Z ]*$', patternMsg = 'Letters only' } = {}) =>
  stringValidation({
    pattern,
    patternMsg,
  });

const zipValidation = ({ min = 5, pattern = '^[0-9]*$', patternMsg = 'Numbers only' } = {}) =>
  stringValidation({
    min,
    pattern,
    patternMsg,
  });

const passwordValidation = ({
  min = 8,
  pattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$',
  patternMsg = 'At least one uppercase, one lowercase, and one digit',
} = {}) =>
  stringValidation({
    min,
    pattern,
    patternMsg,
  });

const confirmPasswordValidation = () => {
  return Yup.string().test('Passwords match', 'Passwords must match', function (value) {
    return this.parent.password === value;
  });
};

const fileValidation = () => Yup.mixed().required();

const arrayValidation = (yupObject, arrayLength = 0) => {
  if (arrayLength == 0) {
    return Yup.array().of(Yup.object().shape(yupObject));
  } else return Yup.array().of(Yup.object().shape(yupObject)).length(arrayLength);
};

export {
  stringValidation,
  companyNameValidation,
  usernameValidation,
  emailValidation,
  phoneValidation,
  cityValidation,
  zipValidation,
  passwordValidation,
  confirmPasswordValidation,
  fileValidation,
  arrayValidation,
};
